//Constans

export const baseRegexp = {
  priceRegex: /^\d{0,8}(\.\d{0,4})?$/,
  emailRegex: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
  phoneRegex: /^\+[0-9]?()[0-9](\s|\S)(\d[0-9]{9})$/,
}
